/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { isProviderAPos } from '../../../services/Provider/Provider.service'
import { useLocation } from 'react-router-dom-v5-compat'
import useUser from '../../Shared/UserProvider/useUser'
import { useDeviceMediaQuery } from '../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { UltyLinkLabel } from '../../Shared/UltyLinkLabel/UltyLinkLabel'
import { Label } from 'semantic-ui-react'

const OrderStatusLabels = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const location = useLocation()
    const {isMobile, isTablet} = useDeviceMediaQuery()

    const queryClient = useQueryClient()
    const currentOrders = queryClient.getQueryData(['orders', 'current']) || []

    const unScheduledOrders = currentOrders.filter(order => !order.isScheduledForLater)
    const scheduledOrders = currentOrders.filter(order => order.isScheduledForLater)

    return (
      <div
        css={css`
            display: grid;
            grid-template-rows: repeat(${(isProviderAPos(user.provider) && isMobile) ? 2 : 1}, 1fr);
            grid-template-columns: repeat(${isMobile ? 2 : 4}, ${isMobile ? '1fr' : isTablet ? '16%' : '12.5%'});
            gap: .5rem;
            margin: .5rem 0;
        `}
      >
          {isProviderAPos(user.provider) && (
            <>
                <UltyLinkLabel
                  to="current"
                  active={location.pathname.includes('current')}
                >
                    {(unScheduledOrders.length > 0) ? (
                        <>
                            <Label color="teal" circular>{unScheduledOrders.length}</Label>
                            <span>{t('order.list.status.current')}</span>
                        </>
                      ) :
                      (<span>{t('order.list.status.current')}</span>)}
                </UltyLinkLabel>

                <UltyLinkLabel
                  to="scheduled"
                  active={location.pathname.includes('scheduled')}
                >
                    {(scheduledOrders.length > 0) ? (
                        <>
                            <Label color="teal" circular>{scheduledOrders.length}</Label>
                            <span>{t('order.list.status.scheduled', { count: scheduledOrders.length === 0 ? 2 : scheduledOrders.length })}</span>
                        </>
                      ) :
                      (<span>{t('order.list.status.scheduled', { count: scheduledOrders.length === 0 ? 2 : scheduledOrders.length })}</span>)}
                </UltyLinkLabel>
            </>
          )}

          <UltyLinkLabel
            to='finished'
            active={location.pathname.includes('finished')}
            label={t('order.list.status.finished')}
          />

          <UltyLinkLabel
            to='untreated'
            active={location.pathname.includes('untreated')}
            label={t('order.list.status.untreated')}
          />
      </div>
    )
}

export { OrderStatusLabels }
